/* ========================================================================== *\
    Imports
/* ========================================================================== */
import { isElement } from 'lodash';

import { subscribe } from '../2-utilities/event';
import {
    SHOW_INFO_BOX as showInfoBox,
    CHANGE_INFO_BOX as changeInfoBox,
    HIDE_INFO_BOX as hideInfoBox
} from '../3-data/consts/eventNames';

/* ========================================================================== *\
    Constants
/* ========================================================================== */
const moduleName = 'info-box',
    baseSelector = `.js-${moduleName}`,
    selectors = {
        base: baseSelector,
        status: `${baseSelector}-status`,
        position: `${baseSelector}-position`,
        hospital: `${baseSelector}-hospital`,
        city: `${baseSelector}-city`
    },
    classNames = {
        hide: '--hide',
        statusTop: '--top',
        statusDefault: '--default',
        statusBottom: '--bottom'
    };

/* ========================================================================== *\
    Functionality
/* ========================================================================== */
function changeStatus(element, type) {
    element.classList.remove(classNames.statusBottom);
    element.classList.remove(classNames.statusTop);
    element.classList.remove(classNames.statusDefault);

    if (type === 'Z') {
        element.classList.add(classNames.statusDefault);
    }

    if (type === 'H') {
        element.classList.add(classNames.statusTop);
    }

    if (type === 'L') {
        element.classList.add(classNames.statusBottom);
    }
}

function changeBox({ detail }) {
    const element = this,
        elements = {
            status: element.querySelector(selectors.status),
            position: element.querySelector(selectors.position),
            hospital: element.querySelector(selectors.hospital),
            city: element.querySelector(selectors.city)
        };

    changeStatus(elements.status, detail.Positie);

    elements.position.innerHTML = detail.Ranking === 0 ? '' : detail.Ranking;
    elements.hospital.innerHTML = detail.Ziekenhuis;
    elements.city.innerHTML = detail.Plaats;
}

function showBox() {
    const element = this;

    element.classList.remove(classNames.hide);
}

function hideBox() {
    const element = this;

    element.classList.add(classNames.hide);
}

function init(baseElement = document.querySelector(baseSelector)) {
    if (!isElement(baseElement)) {
        return;
    }

    subscribe(showInfoBox, showBox.bind(baseElement));
    subscribe(changeInfoBox, changeBox.bind(baseElement));
    subscribe(hideInfoBox, hideBox.bind(baseElement));

    document.addEventListener('click', hideBox.bind(baseElement));
}

init();